module.exports = __webpack_public_path__ + "img/smart5.13aaac4f.svg";